import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Stack } from '@mui/material';
import { useGetProjectQuery } from '~/api/v2/hooks';
import { Tooltip } from '~/components';
import { ProjectActionTypeEnum, useProjectActionState } from '~/hooks';
import { useAppSelector } from '~/redux';
import { selectCurrentUserApplicationRole, selectCurrentUserId } from '~/redux/slices/currentUserSlice';
import { getPriviligies } from '~/utils';

interface TableActionButtonsProps {
  onRefreshButtonClick: () => void;
  onCreateButtonClick: () => void;
}

const TableActionButtons: FC<TableActionButtonsProps> = ({ onCreateButtonClick, onRefreshButtonClick }) => {
  const projectId = +useParams().projectid!;
  const { data: project } = useGetProjectQuery({ projectId });
  const userApplicationRole = useAppSelector(selectCurrentUserApplicationRole);
  const userId = useAppSelector(selectCurrentUserId);
  const userProjectRole = project?.members?.find(({ id }) => id === userId)?.role_id;
  const { isDisabledAction, tooltipMessage } = useProjectActionState({ actionType: ProjectActionTypeEnum.EMR_CLUSTER });
  const canCreate =
    getPriviligies(userProjectRole)?.emrCluster.canCreate || getPriviligies(userApplicationRole)?.emrCluster.canCreate;

  return (
    <Stack direction="row" spacing={3}>
      <CustomButton buttonType="outlined" onClick={onRefreshButtonClick}>
        Refresh
      </CustomButton>
      {canCreate && (
        <Tooltip title={tooltipMessage}>
          <CustomButton onClick={onCreateButtonClick} disabled={isDisabledAction}>
            Create Cluster
          </CustomButton>
        </Tooltip>
      )}
    </Stack>
  );
};

export default TableActionButtons;
